import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-resume-eurobits',
  templateUrl: './resume-eurobits.component.html',
  styleUrls: ['./resume-eurobits.component.scss']
})
export class ResumeEurobitsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
